import React from 'react'

const CardDescription = ({ children }: { children: React.ReactNode }) => (
  <div className="text-xs text-[#252C32]">{children}</div>
)

export default CardDescription
